import { FC } from 'react'
import { Header as MainHeader, NavTabs } from '@mondra/ui-components'
import classNames from 'classnames'

import { UserAvatarMenu } from '../UserAvatarMenu'
import { isFeatureEnabled } from '../../shared/hasFeatures'
import { RELEASE_FEATURE_FLAGS, ROUTES } from '../../const'

interface HeaderProps {
  name: string
}

const navTabOptions = [
  { to: '/', label: 'Home', end: true },
  { to: ROUTES.food, label: 'Food' },
  { to: '/packaging', label: 'Packaging' },
  { to: ROUTES.waterScarcity, label: 'Global' },
]

const Header: FC<HeaderProps> = ({ name }) => {
  const isProjectGlacier = isFeatureEnabled(RELEASE_FEATURE_FLAGS.ENABLE_GLACIER)

  return (
    <MainHeader
      appName="Mondra"
      className="dark"
      path="/"
      right={
        <div className="flex flex-row items-center justify-end gap-x-2">
          <UserAvatarMenu />
        </div>
      }
    >
      {isProjectGlacier && (
        <a
          href="/"
          className="ml-auto text-3xl font-semibold uppercase text-white focus-visible:outline-none"
          style={{ backgroundColor: 'coral' }}
        >
          Glacier B 2026 TEST ENVIRONMENT!!!!!
        </a>
      )}
      <div className="ml-auto flex">
        <NavTabs options={navTabOptions} gapClass="gap-0" />
      </div>
    </MainHeader>
  )
}

export default Header
